import { useContext, createContext } from 'react';
var MotionContext = /*#__PURE__*/createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
export { MotionContext, useVisualElementContext };